import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { createStyles, Badge, BadgeProps } from '@mantine/core';

// Types
import { SurveyStatus } from '../../types';

interface StatusPillProps extends BadgeProps {
    status: SurveyStatus;
}

export const StatusPill: React.FC<StatusPillProps> = ({ status, ...props }) => {
    const { t } = useTranslation('common', { keyPrefix: 'statuses' });
    const color = React.useMemo(() => {
        switch (status) {
            case SurveyStatus.UPCOMING:
                return 'gray';
            case SurveyStatus.PENDING:
                return 'orange';
            case SurveyStatus.SUBMITTED:
                return 'cyan';
            case SurveyStatus.ACCEPTED:
                return 'green';
            case SurveyStatus.REJECTED:
                return 'red';
            default:
                return 'blue';
        }
    }, [status]);

    return (
        <Badge color={color} {...props}>
            {t(status)}
        </Badge>
    );
};
